import React from 'react';
import { ExpandChevronCell } from '../../../../../../../Components/BombiixAGGrid';
import { useMeasurementsDispatch, useMeasurementsState } from '../MeasurementsProvider';

/** Header chevron that collapses / expands every product block at once (BM-9210 req 16), using the
 *  shared BombiixAGGrid `ExpandChevronCell` in controlled mode so it matches the row expand cell. */
const ExpandAllHeader: React.FC = () => {
  const state = useMeasurementsState();
  const dispatch = useMeasurementsDispatch();
  const allCollapsed = state.products.length > 0 && state.collapsedProducts.length === state.products.length;

  return (
    <ExpandChevronCell
      expanded={!allCollapsed}
      onToggle={() => dispatch({ type: 'SET_ALL_COLLAPSED', payload: { collapsed: !allCollapsed } })}
      expandLabel="Expand all products"
      collapseLabel="Collapse all products"
      className="cag-chevron-toggle"
    />
  );
};

export default ExpandAllHeader;
